"use client";
import { useAppSelector } from "src/components/hooks/redux"; // مسیر مناسب را تنظیم کنید
import { setMessage } from "src/redux/slices/message";
import Snackbar from "src/components/elements/Snackbar";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { myAxios } from "@utils/axios";
import { setUser } from "@redux/slices/user";
import { useSession } from "next-auth/react";

export default function ElementOnAllPages() {
  const dispatch = useDispatch();
  const isShow = useAppSelector((state) => state.messages.isShow);
  const messageStatus = useAppSelector((state) => state.messages.severity);
  const message = useAppSelector((state) => state.messages.message);

  useEffect(() => {
    myAxios("/auth/me")
      .then((res) => {
        dispatch(setUser(res.data.data));
      })
      .catch((error) => {
        console.log(error.response);
      });
  }, []);

  return (
    <Snackbar
      open={isShow}
      onClose={() =>
        dispatch(setMessage({ message: "", isShow: false, severity: "" }))
      }
      message={message}
      severity={messageStatus}
    />
  );
}
